import PropTypes from 'prop-types'
import React from 'react'

export class CardUser extends React.Component {
  static propTypes = {
    userComponent: PropTypes.func.isRequired,
    onClick: PropTypes.func,
  }

  handleClick = (event) => {
    const {
      onClick
    } = this.props

    event.stopPropagation()
    event.preventDefault()

    onClick && onClick(event)
  }

  render () {
    const {
      userComponent: UserComponent,
      onClick,

      ...props
    } = this.props

    return (
      <UserComponent
        {...props}
        onClick={this.handleClick}
      />
    )
  }
}

export default CardUser

